import { defaultDeserialiser, defaultSerialiser, } from "../domain";
export class SafeSet {
    #isPrimitive;
    #serialise;
    #deserialise;
    #set;
    #newSet() {
        return this.#isPrimitive
            ? new SafeSet(undefined, undefined)
            : new SafeSet(this.#serialise, this.#deserialise);
    }
    constructor(serialiser, deserialiser, set) {
        this.#isPrimitive = serialiser === undefined && deserialiser === undefined;
        this.#serialise = serialiser ?? defaultSerialiser;
        this.#deserialise = deserialiser ?? defaultDeserialiser;
        this.#set = set ?? new Set();
    }
    clone() {
        const clone = this.#newSet();
        for (const val of this) {
            clone.add(val);
        }
        return clone;
    }
    forEach(callbackfn) {
        for (const value of this) {
            callbackfn(value, value, this);
        }
    }
    entries() {
        const set = this.#set;
        const deserialise = (s) => this.#deserialise(s);
        const it = set.entries();
        return {
            [Symbol.iterator]() {
                return this;
            },
            next() {
                const result = it.next();
                if (result.done)
                    return { done: true, value: undefined };
                const [serialisedVal] = result.value;
                const originalVal = deserialise(serialisedVal);
                return { done: false, value: [originalVal, originalVal] };
            },
        };
    }
    values() {
        return this.keys();
    }
    keys() {
        const set = this.#set;
        const deserialise = (s) => this.#deserialise(s);
        const it = set.entries();
        return {
            [Symbol.iterator]() {
                return this;
            },
            next() {
                const result = it.next();
                if (result.done)
                    return { done: true, value: undefined };
                const [serialisedVal] = result.value;
                const originalVal = deserialise(serialisedVal);
                return { done: false, value: originalVal };
            },
        };
    }
    [Symbol.iterator]() {
        return this.values();
    }
    empty() {
        return this.#newSet();
    }
    clear() {
        this.#set.clear();
    }
    delete(value) {
        const svalue = this.#serialise(value);
        return this.#set.delete(svalue);
    }
    has(value) {
        return this.#set.has(this.#serialise(value));
    }
    add(value) {
        const svalue = this.#serialise(value);
        this.#set.add(svalue);
        return this;
    }
    get size() {
        return this.#set.size;
    }
    toSet() {
        return this.#set;
    }
    static fromList(values) {
        const set = new SafeSet();
        values.forEach((value) => set.add(value));
        return set;
    }
}
export class ChatSet extends SafeSet {
    constructor(values) {
        super((k) => JSON.stringify(k), (k) => JSON.parse(String(k)));
        values?.forEach((v) => this.add(v));
    }
}
